/* eslint-disable */
import {
    greenThemeLight, greenThemeDark, bwThemeLight, bwThemeDark,
    blueThemeLight, blueThemeDark, redThemeLight, redThemeDark,
    orangeThemeLight, orangeThemeDark, purpleThemeLight, purpleThemeDark,
    pinkThemeLight, pinkThemeDark, yellowThemeLight, yellowThemeDark,
    webNeoTheme,
} from '../theme/theme'


export const themeData = {
    theme: webNeoTheme
}


// Choose theme from above